import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EPlantStatus } from "../../../shared/oversight-core/enums/plant-status";
import { ESolarPlantSize } from "../../../shared/oversight-core/enums/solar-plant-size";
import { RootState } from "../../store";

// The Sites list filters other than status (which is selectPlantStatus). They live here rather than
// in the page so that the list and map views share them and they survive opening a site and coming
// back.
export type SitesListFilters = {
  generationServiceProviderId: string;
  solarPlantSize?: ESolarPlantSize;
  searchValue: string;
  pageNumber: number;
};

type Site = {
  siteViewTabId: number;
  selectPlantStatus: EPlantStatus | undefined;
  isHideErrorStatus: boolean;
  isHideActiveAndOfflineStatus: boolean;
  sitesListFilters: SitesListFilters;
};

export const initialSitesListFilters: SitesListFilters = {
  generationServiceProviderId: "",
  solarPlantSize: undefined,
  searchValue: "",
  pageNumber: 0,
};

const initialState: Site = {
  siteViewTabId: 1,
  selectPlantStatus: undefined,
  isHideErrorStatus: false,
  isHideActiveAndOfflineStatus: false,
  sitesListFilters: { ...initialSitesListFilters },
};

export const siteSlice = createSlice({
  name: "station",
  initialState: { ...initialState },
  reducers: {
    setSiteViewTabId: (state, action: PayloadAction<number>) => {
      state.siteViewTabId = action.payload;
    },
    setSelectPlantStatus: (
      state,
      action: PayloadAction<EPlantStatus | undefined>,
    ) => {
      state.selectPlantStatus = action.payload;
    },
    setIsHideErrorStatus: (state, action: PayloadAction<boolean>) => {
      state.isHideErrorStatus = action.payload;
    },
    setIsHideActiveAndOfflineStatus: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.isHideActiveAndOfflineStatus = action.payload;
    },
    updateSitesListFilters: (
      state,
      action: PayloadAction<Partial<SitesListFilters>>,
    ) => {
      state.sitesListFilters = { ...state.sitesListFilters, ...action.payload };
    },
    resetSitesListFilters: (state) => {
      state.sitesListFilters = { ...initialSitesListFilters };
    },
  },
});

export const {
  setSiteViewTabId,
  setSelectPlantStatus,
  setIsHideErrorStatus,
  setIsHideActiveAndOfflineStatus,
  updateSitesListFilters,
  resetSitesListFilters,
} = siteSlice.actions;

export const siteViewTabId = (state: RootState) => state.sites.siteViewTabId;
export const selectPlantStatus = (state: RootState) =>
  state.sites.selectPlantStatus;
export const isHideErrorStatus = (state: RootState) =>
  state.sites.isHideErrorStatus;
export const isHideActiveAndOfflineStatus = (state: RootState) =>
  state.sites.isHideActiveAndOfflineStatus;
export const selectSitesListFilters = (state: RootState) =>
  state.sites.sitesListFilters;
export default siteSlice.reducer;
